import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-system-details',
  templateUrl: './system-details.component.html',
  styleUrls: ['./system-details.component.scss']
})

export class SystemDetailsComponent implements OnInit {

  private ResponseNormalSystemDetails: Subject<any> = new Subject();
  private ResponseWmsSystemDetails: Subject<any> = new Subject();
  public getSystemDetailsDataList: any = {};
  public getSystemDetailsDataListWms: any = {};

  public getSystemDetailsDataListZE: any = {};

  public role: any;
  public roleName: any;
  page = 1;
  public deviceInfoDataList: any = [];
  public deviceInfoDataListWms: any = [];
  public deviceInfoDataListZE: any = [];

  public subDeviceList: any = [];
  uploadFlagSpinner: boolean;
  constructor(private dashboardService: DashboardService, private router: Router, private toastr: ToastrService
    ) {
    this.role = localStorage.role;
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    }
    else if (this.role == '6') {
      this.roleName = 'ze';
    }
    else if (this.role == '7') {
      this.roleName = 'dg';
    }
  }
  ngOnInit() {

    if (this.roleName == 'normal') {

      this.getSystemDetailsNormalData();

    }
    if (this.roleName == 'wms') {
      this.getSystemDetailsWmsData();

    }
    if (this.roleName == 'ze'||this.roleName == 'dg') {
      this.getSystemDetailsZeDgData();

    }

  }

  // Normal User dashboard api call
  getSystemDetailsNormalData() {

    this.dashboardService.getSystemDetailsData()
    .pipe(takeUntil(this.ResponseNormalSystemDetails))
    .subscribe(
      async data => {
        if (data.status) {
          this.getSystemDetailsDataList = data.systemDetails;
          this.deviceInfoDataList = data.device_info;

        }  else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
  }

    // Wms User dashboard api call
    getSystemDetailsWmsData() {

      this.dashboardService.getWmsSystemDetailsData()
      .pipe(takeUntil(this.ResponseWmsSystemDetails))
      .subscribe(
        async data => {
          if (data.status) {
            this.getSystemDetailsDataListWms = data.systemDetails;
            this.deviceInfoDataListWms = data.device_info;

          }  else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
    }

    getSystemDetailsZeDgData() {

      this.dashboardService.getSystemDetailsZEDGData()
      .pipe(takeUntil(this.ResponseNormalSystemDetails))
      .subscribe(
        async data => {
          if (data.status) {
            this.getSystemDetailsDataListZE = data.systemDetails;
            this.deviceInfoDataListZE = data.device_info;

          }  else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
    }
  ngOnDestroy() {
    this.ResponseNormalSystemDetails.next();
    this.ResponseNormalSystemDetails.complete();
    this.ResponseWmsSystemDetails.next();
    this.ResponseWmsSystemDetails.complete();

  }


}
